import { DiscountCodeFormValue } from "./partials/DiscountCodeForm/types";

export const initialValues: DiscountCodeFormValue = {
  input: {
    name: null,
    code: null,
    amount: null,
    maxUse: null,
    expireAt: null,
    isApplicableToAllEvents: false,
    numberOfTicketsAppliedInOrder: null,
    events: [],
  },
};
